import { CountriesResp } from 'types/api/response/countries-resp'

import { api } from './api'

export const getCountries = (locale?: string) =>
  api.get<CountriesResp>('/countries', {
    params: locale ? { locale } : {},
  })
